module.exports = __webpack_public_path__ + "static/media/Ooppah_Clube_Antonio_Adolfo.788e4a83.pdf";